import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveInstance = (state, instance) => state.some((item) => item.firmId === instance.firmId);
const getInstance = (state, instance) => state.find((item) => item.firmId === instance.firmId);

export const firmsSlice = createSlice({
  name: 'firms',
  initialState: initialState,
  reducers: {
    clearFirms: (state) => {
      return initialState;
    },

    addFirm: (state, action) => {
      const newFirm = action.payload;
      if (haveInstance(state, newFirm)) {
        // merge in the state (possibly contactIds or facilities) of the new object
        const existingFirm = getInstance(state, newFirm);
        const updatedFirm = { ...existingFirm, ...newFirm };
        const otherFirms = state.filter((firm) => firm.firmId !== newFirm.firmId);
        return [updatedFirm, ...otherFirms];
      } else {
        return [...state, newFirm];
      }
    },

    addFirms: (state, action) => {
      return [...state, ...action.payload];
    },

    updateFirm: (state, action) => {
      const newFirmState = action.payload;
      if (haveInstance(state, newFirmState)) {
        // merge in the state (possibly contactIds or facilities) of the new object
        const existingFirm = getInstance(state, newFirmState);
        const updatedFirm = { ...existingFirm, ...newFirmState };
        const otherFirms = state.filter((firm) => firm.firmId !== newFirmState.firmId);
        return [updatedFirm, ...otherFirms];
      } else {
        return [...state, newFirmState];
      }
    },
  },
});

export const { clearFirms, addFirm, addFirms, updateFirm } = firmsSlice.actions;

export default firmsSlice.reducer;
